import React from 'react';
import {Spin} from 'antd';

import './styles.scss';

interface LoaderProps {
  text?: string;
  size?: 'small' | 'large';
}

// TODO take a look on <Spin spinning={isLoading}>

export const Loader: React.FC<LoaderProps> = ({text = 'Loading...', size = 'large'}) => (
  <div className="loader">
    <Spin size={size} />
    {text && <span>{text}</span>}
  </div>
);
